import {Component, Input, OnInit} from '@angular/core';
import {Person} from '../../../../class/person';
import {AbstractQuoteRow} from '../../abstract-quote-row';

@Component({
  selector: 'app-quote-row',
  templateUrl: './quote-row.component.html',
  styleUrls: ['./quote-row.component.css']
})
export class QuoteRowComponent extends AbstractQuoteRow<Person> implements OnInit {

  @Input()
  person: Person;

  selectedCover: number;

  coverString = 'Max:';

  constructor() {
    super();
  }

  ngOnInit() {
    this.selectedCover = this.getCover(this.person);
  }

  getCover(person: Person) {
    if (person) {
      switch (this.safeguardType) {
        case 0: {
          this.coverString = 'Capitale';
          return person.coverForDeadCase;
        }
        case 1: {
          this.coverString = 'Capitale';
          return person.coverForIp;
        }
        case 2: {
          this.coverString = 'Rendita Annua';
          return person.ipProcapite;
        }
        case 3: {
          this.coverString = 'Rendita Annua';
          return person.coverForNoSelfSuf;
        }
        case 4: {
          this.coverString = 'Capitale';
          return person.coverForDreadDisease;
        }
      }
    }
  }

  getRowObject(): Person {
    return this.person;
  }

}
